import React from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import useChangeCheck from "./useChangeCheck";
import ChangeCheckContext from "../support/ChangeCheckContext";
function StringInput(props) {

    const {disable} = React.useContext(ChangeCheckContext)
    const { onChange, getStyle } = useChangeCheck(props.onChange);

    function getValue(){
        if (props.value === null){
            return ""
        }
        return props.value
    }

    return (
        <>
            {props.label ? <Form.Label htmlFor="basic-url">{props.label}</Form.Label> : null}
            <InputGroup className="mb-3">
                <Form.Control disabled={disable} name={props.name} onChange={onChange} value={getValue()}
                              style={getStyle()}/>
            </InputGroup>
        </>
    )
}

export default StringInput
